const RESERVED_NAMES = /^(con|prn|aux|nul|com[1-9]|lpt[1-9])(?:\.|$)/i;

function decodeContractTitle(value) {
  const entities = {
    amp: "&",
    quot: '"',
    apos: "'",
    nbsp: " ",
    ldquo: "“",
    rdquo: "”",
    lsquo: "‘",
    rsquo: "’"
  };
  return String(value || "").replace(
    /&(#x[0-9a-f]+|#\d+|amp|quot|apos|nbsp|ldquo|rdquo|lsquo|rsquo);/gi,
    (entity, code) => {
      if (code[0] !== "#") return entities[code.toLowerCase()];
      const point =
        code[1].toLowerCase() === "x"
          ? parseInt(code.slice(2), 16)
          : Number(code.slice(1));
      return point > 0 &&
        point <= 0x10ffff &&
        !(point >= 0xd800 && point <= 0xdfff)
        ? String.fromCodePoint(point)
        : entity;
    }
  );
}

function sanitizeTitle(value) {
  const normalized = decodeContractTitle(value)
    .normalize("NFC")
    .split("")
    .filter(character => {
      const code = character.charCodeAt(0);
      return code > 31 && code !== 127;
    })
    .join("")
    .replace(/[\\/:*?"<>|]/g, "-")
    .replace(/\s+/g, " ")
    .replace(/-+/g, "-")
    .replace(/[. ]+$/g, "")
    .trim();
  const safe =
    normalized && !RESERVED_NAMES.test(normalized) ? normalized : "Contract";
  return safe.slice(0, 120).replace(/[. ]+$/g, "") || "Contract";
}

function signedDate(signatures) {
  const contractSignatures = (Array.isArray(signatures) ? signatures : [])
    .filter(
      signature =>
        signature &&
        signature.type === "contract" &&
        ["host", "guest"].includes(signature.party) &&
        signature.created_at
    )
    .map(signature => ({
      party: signature.party,
      date: new Date(signature.created_at)
    }))
    .filter(signature => !Number.isNaN(signature.date.getTime()));
  const parties = new Set(contractSignatures.map(signature => signature.party));
  if (!parties.has("host") || !parties.has("guest")) return "";
  const dates = contractSignatures
    .map(signature => signature.date)
    .sort((left, right) => right.getTime() - left.getTime());
  return dates[0] ? dates[0].toISOString().slice(0, 10) : "";
}

function inferContractTitle(generatedText) {
  const heading = String(generatedText || "").match(
    /<h2\b[^>]*>([\s\S]*?)<\/h2>/i
  );
  if (!heading) return "";
  return decodeContractTitle(heading[1].replace(/<[^>]*>/g, ""))
    .replace(/&quot;|&#34;/gi, '"')
    .replace(/&ldquo;|&#8220;/gi, "“")
    .replace(/&rdquo;|&#8221;/gi, "”")
    .replace(/^[\s"'“”‘’]+|[\s"'“”‘’]+$/g, "")
    .trim();
}

function buildContractFilename(title, signatures) {
  const date = signedDate(signatures);
  return `${sanitizeTitle(title)} - ${date || "Draft"}.pdf`;
}

module.exports = {
  decodeContractTitle,
  buildContractFilename,
  inferContractTitle,
  sanitizeTitle,
  signedDate
};
